<template>
    <form @submit.prevent="sendRequest()" class="tag-registration-widget card">
        <div class="card-header">Tag registration mode</div>
        <div class="card-body">
            <div class="form-group">
                <input class="form-control" v-model="lockID" placeholder="Lock ACA ID..." />
            </div>
        </div>
        <div class="card-footer">
            <button class="btn btn-primary" type="submit">Request tag registration mode</button>
        </div>
    </form>
</template>
<script>
import Hardware from "../../Services/Hardware";

export default {

    	data: () => { return {
    		lockID: '',
        }},

        methods: {

    		sendRequest: function() {

    			Hardware.enableTagRegistration(this.lockID).then((res) => {
    				console.log(res);
    				alert("Tag registration mode requested! Status: " + res.status);
                })

            }

        }

    }
</script>
